export enum CurrencyType {
  foreign,
  local,
}
